export const ARCADE_LEVELS = [
  {
    id: 'doctor',
    levelNumber: 1,
    characterName: 'Dr. Tempus',
    title: 'THE DOCTOR',
    targetMAE: 120,
    timeHorizon: 10,
    difficulty: 'EASY',
    difficultyColor: '#4caf50',
    introMessage: "Hey, I'm the doctor! My time perception is not very precise — my patients always complain about having to wait. So you'll have it easy on this one!",
    challenge: 'Beat my MAE of 120ms',
    background: 'doctor',
    corridorColor: '#0c1628',
    corridorAccent: '#d4a820',
    enterEmoji: '🏥',
    enterLabel: 'ENTER THE OFFICE',
    characterWidth: 220,
    characterHeight: 310,
  },
  {
    id: 'rider',
    levelNumber: 2,
    characterName: 'The Rider',
    title: 'THE RIDER',
    targetMAE: 90,
    timeHorizon: 12,
    difficulty: 'MEDIUM',
    difficultyColor: '#f5c800',
    introMessage: "I am the Rider. My clients receive the pizza on time, but some of the times they complain. Beat me if you want your pizza!",
    challenge: 'Beat my MAE of 90ms',
    background: 'rider',
    corridorColor: '#0d1200',
    corridorAccent: '#f5c800',
    enterEmoji: '🛵',
    enterLabel: 'ACCEPT DELIVERY',
    characterWidth: 220,
    characterHeight: 271,
  },
  {
    id: 'baker',
    levelNumber: 3,
    characterName: 'The Baker',
    title: 'THE BAKER',
    targetMAE: 65,
    timeHorizon: 15,
    difficulty: 'HARD',
    difficultyColor: '#f44336',
    introMessage: "In order to bake you need to be very precise with time! None of my cakes are burned!",
    challenge: 'Beat my MAE of 65ms',
    background: 'baker',
    corridorColor: '#1a0e05',
    corridorAccent: '#d4880a',
    enterEmoji: '🥧',
    enterLabel: 'ENTER THE BAKERY',
    characterWidth: 220,
    characterHeight: 308,
  },
  {
    id: 'traindriver',
    levelNumber: 4,
    characterName: 'The Train Driver',
    title: 'THE TRAIN DRIVER',
    targetMAE: 45,
    timeHorizon: 18,
    difficulty: 'EXPERT',
    difficultyColor: '#e53935',
    introMessage: "The Shinkansen is never late, I am extremely precise!",
    challenge: 'Beat my MAE of 45ms',
    background: 'traindriver',
    corridorColor: '#0a1428',
    corridorAccent: '#4a80c8',
    enterEmoji: '🚄',
    enterLabel: 'BOARD THE SHINKANSEN',
    characterWidth: 220,
    characterHeight: 310,
  },
  {
    id: 'bonzo',
    levelNumber: 5,
    characterName: 'Bonzo',
    title: 'THE DRUMMER',
    targetMAE: 35,
    timeHorizon: 20,
    difficulty: 'MASTER',
    difficultyColor: '#b71c1c',
    introMessage: "I'm Bonzo, the drummer of Led Zeppelin! How do you think that I played Black Dog? I never missed a beat!",
    challenge: 'Beat my MAE of 35ms',
    background: 'bonzo',
    corridorColor: '#0a0404',
    corridorAccent: '#cc2200',
    enterEmoji: '🥁',
    enterLabel: 'TAKE THE STAGE',
    characterWidth: 260,
    characterHeight: 310,
  },
  {
    id: 'watchmaker',
    levelNumber: 6,
    characterName: 'Klaus Meier',
    title: 'THE WATCHMAKER',
    targetMAE: 32,
    timeHorizon: 22,
    difficulty: 'MASTER',
    difficultyColor: '#b71c1c',
    introMessage: "I am Klaus Meier, the Watchmaker. I am in charge of setting everyone's time, no one is more precise than me!",
    challenge: 'Beat my MAE of 32ms',
    background: 'watchmaker',
    corridorColor: '#1a0e05',
    corridorAccent: '#c8a820',
    enterEmoji: '⌚',
    enterLabel: 'ENTER THE WATCH SHOP',
    characterWidth: 220,
    characterHeight: 310,
  },
];

export const getLevelById = (id) => ARCADE_LEVELS.find(l => l.id === id);
export const getLevelByNumber = (n) => ARCADE_LEVELS.find(l => l.levelNumber === n);
